<script setup lang="ts">
const currentYear = new Date().getFullYear();
</script>

<template>
  <footer class="global-footer">
    <div class="footer-content-wrapper">
      <div class="footer-left">
        &copy; {{ currentYear }} BARBRI. All rights reserved.
      </div>
      <div class="footer-right">
        <a href="https://www.barbri.com/terms-conditions" target="_blank">Terms and Conditions</a>
        <a href="https://www.barbri.com/privacy-policy" target="_blank">Privacy Policy</a>
        <!-- TODO: this comes later, as a OneTrust integration, likely post-MVP -->
        <!-- <RouterLink to="/legal/privacy-choices">Your Privacy Choices</RouterLink> -->
      </div>
    </div>
  </footer>
</template>
